import * as React from "react";
import { careerData } from "../data";
import { getLocalizedText } from "../util";
import { useLang } from "../lang";

const Career: React.FC = () => {
  const { langEn } = useLang();
  return (
    <div id="career" className="container justify-content-center mb-2">
      <p className="title">{langEn ? "Career" : "経歴"}</p>

      <div className="row">
        <div className="col-md-12 mb-2">
          <ul className="mb-0">
            {careerData.map((item, i) => (
              <li key={i} className="mb-1">
                <span className="job">{getLocalizedText(item.affiliation, langEn)}</span>:
                <span className="ml-1">{getLocalizedText(item.role, langEn)}</span>
                <span className="ml-1">({getLocalizedText(item.term, langEn)})</span>
                <a href={getLocalizedText(item.link, langEn)} className="ml-2 icon-link"></a>
                <br />
                <span>
                  <small>{getLocalizedText(item.topics, langEn)}</small>
                </span>
                {item.others ? (
                  <span>
                    <small>, {getLocalizedText(item.others, langEn)}</small>
                  </span>
                ) : (
                  ""
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Career;
